<template>
  <div class="createarticles">
    <div class="wrapper" :class="{ expanded: activeLang }">
      <div class="title">
        <div class="title-content">
          <h1>{{ $t("admin.title") }}</h1>
          <div class="border"></div>
        </div>
        <div class="editLang" v-if="activeLang">
          <div class="row">
            <h3>
              {{ $t("admin.prevLang") }} <span> {{ activeLang }} </span>
              {{ $t("admin.lang") }}.
            </h3>
            <div class="preferredLang">
              <router-link
                :to="
                  $staffI18nRoute({
                    name: 'PreferredLang',
                  })
                "
              >
                {{ $t("admin.change_language") }}
              </router-link>
              <div class="border"></div>
            </div>
          </div>
          <p v-if="activeLang === 'uz'">
            {{ $t("admin.changeLang") }}
          </p>
        </div>
      </div>

      <div style="width: 100%; display: flex; justify-content: space-between">
        <TgBtn
          :editId="parseInt(editId)"
          :label="$t('admin.msgToTg')"
          :activeLang="activeLang"
          :actionType="''"
        />
        <TgBtn
          :editId="parseInt(editId)"
          :label="$t('admin.mediaToTg')"
          :activeLang="activeLang"
          :actionType="'image=true'"
        />
        <TgBtn
          :editId="parseInt(editId)"
          :label="$t('admin.videoToTg')"
          :activeLang="activeLang"
          :actionType="'video=true'"
        />
      </div>

      <div
        class="error-messages"
        v-if="
          errorMessages?.title ||
          errorMessages?.title_kr ||
          errorMessages?.brief ||
          errorMessages?.brief_kr ||
          errorMessages?.description ||
          errorMessages?.description_kr ||
          errorMessages?.image ||
          errorMessages?.video ||
          errorMessages?.non_field_errors
        "
      >
        <img src="@/assets/staffImage/error.png" alt="" />
        <h2>{{ $t("admin.comment") }}</h2>
      </div>

      <div class="warning" v-if="errorMessages?.tags">
        <img :src="require('@/assets/staffImage/warning.png')" alt="" />
        <h2>Пожалуйста, исправьте ошибки ниже</h2>
      </div>

      <div class="success" v-if="success">
        <i class="fas fa-check"></i>
        <h2>{{ $t("admin.success_msg") }}</h2>
      </div>

      <!-- content-margin -->
      <form v-if="activeLang" @submit.prevent="save()">
        <div class="uzLang" v-if="activeLang === 'uz'">
          <h1>
            {{ $t("admin.latinlang") }} {{ $t("admin.latinlangOne") }}
            <span> {{ $t("admin.kr") }} </span>
          </h1>
          <div class="uzLangContent">
            <div class="table">
              <div class="text">
                <h2>{{ $t("admin.contentTitle") }}</h2>
                <div class="text-input">
                  <h3 v-if="errorMessages.title_kr">
                    {{ $t("admin.video") }}
                  </h3>
                  <h3
                    v-for="(item, index) in errorMessages.non_field_errors"
                    :key="index"
                  >
                    {{ $t("admin.repeatable_fields") }}
                  </h3>
                  <input
                    v-model="initModel.title_kr"
                    @input="handleModelChange"
                    type="text"
                    :placeholder="$t('admin.contentTitle')"
                  />
                </div>
              </div>
              <div class="brief">
                <h2>{{ $t("admin.brief") }}</h2>
                <div class="brief-input">
                  <h3 v-if="errorMessages.brief_kr">
                    {{ $t("admin.video") }}
                  </h3>
                  <textarea
                    v-model="initModel.brief_kr"
                    @input="handleModelChange"
                    class="brief"
                    :placeholder="$t('admin.brief')"
                  ></textarea>
                </div>
              </div>
            </div>
            <!-- description -->
            <div class="description">
              <h2>{{ $t("admin.description") }}</h2>
              <div class="editor">
                <h3 v-if="errorMessages.description_kr">
                  {{ $t("admin.video") }}
                </h3>

                <div
                  class="editorBlog"
                  style="border: 1px solid black; border-radius: 0.25rem"
                >
                  <ckeditor
                    :editor="editor"
                    @input="handleModelChange"
                    v-model="initModel.description_kr"
                    :config="editorConfig"
                  ></ckeditor>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="anotherLang">
          <h1 v-if="activeLang === 'uz'">
            {{ $t("admin.latinlang") }} {{ $t("admin.latinlangOne") }}
            <span>{{ $t("admin.latin") }}</span>
          </h1>
          <div class="anotherLangContent">
            <div class="table">
              <!-- <h3 v-for="(item, index) in errorMessages.title" :key="index">
                {{ item }}
              </h3> -->

              <div class="text">
                <h2>{{ $t("admin.contentTitle") }}</h2>
                <div class="text-input">
                  <h3 v-if="errorMessages.title">
                    {{ $t("admin.video") }}
                  </h3>
                  <h3
                    v-for="(item, index) in errorMessages.non_field_errors"
                    :key="index"
                  >
                    {{ $t("admin.repeatable_fields") }}
                  </h3>
                  <input
                    v-model="initModel.title"
                    @input="handleModelChange"
                    type="text"
                    :placeholder="$t('admin.contentTitle')"
                  />
                </div>
              </div>
              <div class="brief">
                <h2>{{ $t("admin.brief") }}</h2>
                <div class="brief-input">
                  <h3 v-if="errorMessages.brief">
                    {{ $t("admin.video") }}
                  </h3>
                  <textarea
                    v-model="initModel.brief"
                    @input="handleModelChange"
                    class="brief"
                    :placeholder="$t('admin.brief')"
                  ></textarea>
                </div>
              </div>
            </div>
            <!-- description -->
            <div class="description">
              <h2>{{ $t("admin.description") }}</h2>
              <div class="editor">
                <h3 v-if="errorMessages.description">
                  {{ $t("admin.video") }}
                </h3>
                <div
                  class="editorBlog"
                  style="border: 1px solid black; border-radius: 0.25rem"
                >
                  <ckeditor
                    class="ckeditor"
                    @input="handleModelChange"
                    :editor="editor"
                    v-model="initModel.description"
                    :config="editorConfig"
                  ></ckeditor>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- files -->
        <div class="files">
          <div class="files-flex">
            <div class="files-flex-content">
              <h2 style="font-weight: 300">{{ $t("admin.media") }}</h2>
              <div class="files-input" id="video">
                <h3 v-for="(item, index) in errorMessages.video" :key="index">
                  {{ item }}
                </h3>
                <input
                  @change="videoChange()"
                  ref="video"
                  type="file"
                  accept="video/mp4"
                  :label="$t('admin.selectFile')"
                  :required="videoRequired"
                />
              </div>
            </div>
            <h3>
              {{ $t("admin.atMoment") }}
              <span> {{ videoName }} </span>
            </h3>
            <button @click="removeFile()" v-if="videoUrl">
              {{ $t("admin.delete") }}
            </button>
          </div>
          <div class="files-flex">
            <div class="files-flex-content">
              <h2>{{ $t("admin.image") }}</h2>
              <div class="files-input">
                <h3 v-if="errorMessages.image">{{ $t("admin.video") }}</h3>
                <input
                  @change="imageChange()"
                  ref="image"
                  type="file"
                  accept="image/Jpeg, image/png"
                  :label="$t('admin.selectFile')"
                />
              </div>
            </div>
            <h3>
              {{ $t("admin.atMoment") }}
              <span> {{ imageName }}</span>
            </h3>
          </div>
          <div class="display">
            <div class="display-content" v-if="mediaBar">
              <p v-if="imageUrl">{{ $t("admin.image") }}</p>
            </div>
            <div>
              <img v-if="imageUrl" :src="imageUrl" class="image" alt="" />
            </div>
          </div>
        </div>
        <!-- tags -->
        <div class="categories">
          <div class="tegi">
            <h2>{{ $t("admin.tags") }}</h2>
          </div>

          <div class="avialableSection">
            <div class="avialableTags">
              <div class="avialableTitle">
                <h1>{{ $t("admin.avialable") }}</h1>
              </div>
              <div class="avialableSearch">
                <i class="fas fa-search"></i>
                <input
                  type="text"
                  :placeholder="$t('admin.filter')"
                  v-model="searchQuery"
                  @input="searchBar"
                />
              </div>
              <select multiple ref="avialableTags" size="8">
                <option
                  @dblclick="addSelected()"
                  :value="index"
                  :key="item.id"
                  v-for="(item, index) in searchQuery.length === 0
                    ? availableTagsList
                    : searchTagsList"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
            <button class="selectAll" @click.prevent="setAll('available')">
              <span>{{ $t("admin.selectAll") }}</span>
              <div class="icon">
                <i class="fas"></i>
              </div>
            </button>
          </div>
          <div class="arrows">
            <div class="arrowRight">
              <i class="fas" @click="addSelected()"></i>
            </div>
            <div class="arrowLeft">
              <i class="fas" @click="removeSelected()"></i>
            </div>
          </div>
          <div class="selectedTags">
            <h4 v-for="(item, index) in errorMessages.tags" :key="index">
              {{ $t("admin.video") }}
            </h4>
            <div class="selectedSection">
              <div class="selectedTitle">
                <h1>{{ $t("admin.selected") }}</h1>
              </div>
              <select multiple ref="selectedTags" size="8">
                <option
                  @dblclick="removeSelected()"
                  :value="index"
                  :key="item.id"
                  v-for="(item, index) in selectedTagsList"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
            <button class="deleteAll" @click.prevent="setAll('selected')">
              <div class="icon">
                <i class="fas"></i>
              </div>
              <span>
                {{ $t("admin.removeAll") }}
              </span>
            </button>
          </div>
          <div class="regionsBar" v-if="showRegions">
            <h5 v-for="(item, index) in errorMessages.tags" :key="index">
              {{ $t("admin.regions_selected") }}
            </h5>
            <div class="regionsSelect">
              <div class="regionsTitle">
                <h2>{{ $t("admin.regions") }}</h2>
              </div>
              <select size="8" ref="regionsBarList" v-if="!isMobile">
                <option
                  @dblclick="selectRegions()"
                  class="countriesBarSelect"
                  :value="index"
                  :key="item.id"
                  v-for="(item, index) in regionsList"
                >
                  {{ item.name }}
                </option>
              </select>
              <select size="1" ref="regionsBarList" v-if="isMobile">
                <option
                  @click="selectRegions()"
                  class="countriesBarSelect"
                  :value="index"
                  :key="item.id"
                  v-for="(item, index) in regionsList"
                >
                  {{ item.name }}
                </option>
              </select>

              <button @click.prevent="selectRegions()">Выбрать</button>
              <p>
                {{ $t("admin.selectedRegions") }} :
                <span>{{ activeRegion }}</span>
              </p>
            </div>
          </div>
          <div class="country" v-if="showCountry">
            <h5 v-for="(item, index) in errorMessages.tags" :key="index">
              {{ $t("admin.country_selected") }}
            </h5>
            <div class="countries">
              <div class="countryTitle">
                <h1>{{ $t("admin.country") }}</h1>
              </div>
              <div class="countrySearch" v-if="!isMobile">
                <i class="fas fa-search"></i>
                <input
                  type="text"
                  :placeholder="$t('admin.search')"
                  v-model="searchCountry"
                  @input="searchCont"
                />
              </div>
              <select size="8" ref="countryList" v-if="!isMobile">
                <option
                  @dblclick="selectCountry()"
                  :value="index"
                  :key="item.id"
                  v-for="(item, index) in searchCountry.length === 0
                    ? staffPageCountries
                    : searchCountryList"
                >
                  {{ item.name }}
                </option>
              </select>
              <select size="1" ref="countryList" v-if="isMobile">
                <option
                  @dblclick="selectCountry()"
                  :value="index"
                  :key="item.id"
                  v-for="(item, index) in searchCountry.length === 0
                    ? staffPageCountries
                    : searchCountryList"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div class="selectCountry">
              <button @click.prevent="selectCountry()">Выбрать</button>
              <p>
                {{ $t("admin.selectedCountry") }}:
                <span>
                  {{ activeCountry }}
                </span>
              </p>
            </div>
          </div>
          <h3>{{ $t("admin.commandControl") }}</h3>
          <!-- news -->
          <div class="news-left">
            <h3 v-if="errorMessages.sub_category">
              {{ $t("admin.video") }}
            </h3>
            <div class="news">
              <h2>{{ $t("admin.newsCategory") }}</h2>
              <select ref="news" @input="getCategory()">
                <option value=""></option>
                <option
                  :value="`${item?.category?.slug}|${item?.id}`"
                  :key="index"
                  v-for="(item, index) in categories"
                  required
                >
                  {{ item.name }} | {{ item.category.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="status" v-if="user.is_journalist">
            <h2>{{ $t("admin.status") }}</h2>
            <select size="1" @change="getStatus">
              <option value="published">published</option>
              <option value="moderation">moderation</option>
              <option value="declined">declined</option>
            </select>
          </div>
          <div class="check">
            <input
              type="checkbox"
              v-model="initModel.draft"
              @input="setDraft()"
              id="check"
            />
            <label for="check"> {{ $t("admin.draft") }} </label>
          </div>
          <div class="date">
            <div class="calendar">
              <h2>{{ $t("admin.date") }}</h2>

              <Datepicker
                @update:modelValue="handleModelChange"
                v-model="initModel.pub_date"
              >
              </Datepicker>
            </div>
            <h3>{{ $t("admin.explanationDate") }}</h3>
          </div>
        </div>
        <!-- links -->
        <div class="links">
          <div class="mr">
            <button type="submit" @click.prevent="save('edit')" class="link">
              {{ $t("admin.editing") }}
            </button>
            <button class="link" type="submit">
              {{ $t("admin.save") }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>



<script>
/* eslint-disable */
import { reactive, ref, computed, nextTick, onBeforeUnmount } from "vue";
import { useFormatter } from "@/utils/formatter";
import { useStore } from "vuex";
import { staffCountries, staffRegions } from "@/utils/constants";
import { search } from "ss-search";
import { createArticle, editArticle, getArticle } from "@/network/v2";
import { useRoute, useRouter } from "vue-router";
import { useLanguage } from "@/utils/language";
import { useCkeditor } from "@/utils/ckeditor";
import CKEditor from "@ckeditor/ckeditor5-vue";
import TgBtn from "@/components/staff/Tg-btn.vue";
import Datepicker from "vue3-date-time-picker";
import "vue3-date-time-picker/dist/main.css";

export default {
  components: {
    Datepicker,
    TgBtn,
    ckeditor: CKEditor.component,
  },
  setup() {
    const { removeItemFromArray } = useFormatter();

    // image
    const image = ref("");
    const imageUrl = ref("");
    const imageName = ref("");
    const imageRequired = ref(false);
    // video
    const video = ref(null);
    const videoUrl = ref(null);
    const videoName = ref("");
    const videoRequired = ref(false);
    // show image or video
    const showDisplayContent = ref();
    // selected Tags
    const selectedTags = ref(null);
    const selectedTagsList = ref([]);
    // avialable Tags
    const avialableTags = ref([]);
    const availableTagsList = ref([]);
    // search tags
    const searchTagsList = ref([]);
    const searchCountryList = ref([]);
    const searchCountry = ref("");
    const searchQuery = ref("");
    // countries
    const countryList = ref([]);
    const showCountry = ref(false);
    const activeCountry = ref(null);
    const staffPageCountries = ref([]);
    // regions
    const regionsList = ref([]);
    const regionsBarList = ref([]);
    const showRegions = ref(false);
    const activeRegion = ref(null);
    // news Category
    const news = ref([]);
    const selected = ref(false);
    // success message
    const success = ref(false);
    // vuex store
    const store = useStore();
    // route
    const route = useRoute();
    const router = useRouter();
    // isMObile
    const isMobile = ref();

    // i18 lang
    const { i18nRoute } = useLanguage();

    const activeLang = ref(route.params.lang);
    activeLang.value = activeLang.value.substr(5, activeLang.value.length);
    activeLang.value = activeLang.value === "uz-to" ? "uz" : activeLang.value;
    let editId = route.params.id || false;

    const initModel = reactive({
      draft: false,
      tag_ids: [],
      // sub_category: 0,
      pub_date: new Date(),
    });

    // err
    const errorMessages = reactive({
      title: false,
      brief: false,
      description: false,
      sub_category: false,
    });

    const handleResize = () => {
      isMobile.value = window.innerWidth <= 414;
    };

    if (typeof window !== "undefined") {
      isMobile.value = window.innerWidth <= 414;
      window.addEventListener("resize", handleResize);
    }

    onBeforeUnmount(() => {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", handleResize);
      }
    });

    // media
    const mediaBar = ref(
      typeof window !== "undefined" && window.innerWidth <= 414
    );

    const imageChange = () => {
      const file = image.value?.files[0];
      imageUrl.value = URL.createObjectURL(file);
      showDisplayContent.value = mediaBar;

      imageUrl.value = URL.createObjectURL(file);
      const fileName = image.value.files[0].name;

      imageName.value = fileName;

      initModel.image = file;

      handleModelChange();
    };

    const videoChange = () => {
      const file = video.value.files[0];

      videoUrl.value = URL.createObjectURL(file);
      const fileName = video.value.files[0].name;

      videoName.value = fileName;

      initModel.video = file;

      handleModelChange();
    };

    const removeFile = () => {
      delete initModel.video;

      videoUrl.value = null;
      video.value = null;
      videoName.value = null;

      store.commit("flushNewArticle");

      handleModelChange();
    };

    // add and remove selects
    const addSelected = () => {
      for (const option of avialableTags.value.options) {
        if (option.selected) {
          selectedTagsList.value.push(availableTagsList.value[option.value]);
          initModel.tag_ids.push(
            parseInt(availableTagsList.value[option.value].id)
          );
          removeItemFromArray(availableTagsList.value, option.value);
        }
      }

      handleModelChange();
    };

    const pushedTags = (tag_ids) => {
      for (const option of selectedTags.value.options) {
        if (option.value === initModel.tag_ids) {
          option.selected = true;
          initModel.tags = tag_ids;
        } else {
          option.selected = false;
        }
      }
    };

    const setAll = (val) => {
      if (val === "available") {
        for (const option of avialableTags.value.options) {
          selectedTagsList.value.push(availableTagsList.value[option.value]);
          initModel.tag_ids.push(
            parseInt(availableTagsList.value[option.value].id)
          );
        }
        availableTagsList.value = [];
      } else {
        console.log(selectedTagsList.value);
        for (const option of selectedTags.value.options) {
          if (
            staffCountries.includes(selectedTagsList.value[option.value].slug)
          ) {
            staffPageCountries.value.push(selectedTagsList.value[option.value]);
          } else if (
            staffRegions.includes(selectedTagsList.value[option.value].slug)
          ) {
            regionsList.value.push(selectedTagsList.value[option.value]);
          } else {
            availableTagsList.value.push(selectedTagsList.value[option.value]);
          }

          // availableTagsList.value.push(selectedTagsList.value[option.value]);
          // initModel.tag_ids.pop(selectedTagsList.value[option.value]);
        }
        selectedTagsList.value = [];
      }
      handleModelChange();
    };

    const selectCountry = () => {
      for (const option of countryList.value.options) {
        if (option.selected) {
          activeCountry.value = staffPageCountries.value[option.value].name;
          selectedTagsList.value.push(staffPageCountries.value[option.value]);
          initModel.tag_ids.push(parseInt(option.value));
          removeItemFromArray(staffPageCountries.value, option.value);
        }
      }
      handleModelChange();
    };

    const selectRegions = () => {
      for (const option of regionsBarList.value.options) {
        if (option.selected) {
          activeRegion.value = regionsList.value[option.value].name;
          selectedTagsList.value.push(regionsList.value[option.value]);
          initModel.tag_ids.push(parseInt(regionsList.value[option.value].id));
          removeItemFromArray(regionsList.value, option.value);
          handleModelChange();
          console.log(regionsList.value[option.value].name);
        }
      }
    };

    const removeSelected = () => {
      for (const option of selectedTags.value.options) {
        if (option.selected) {
          if (
            staffCountries.includes(selectedTagsList.value[option.value].slug)
          ) {
            staffPageCountries.value.push(selectedTagsList.value[option.value]);
          } else if (
            staffRegions.includes(selectedTagsList.value[option.value].slug)
          ) {
            regionsList.value.push(selectedTagsList.value[option.value]);
          } else {
            availableTagsList.value.push(selectedTagsList.value[option.value]);
          }

          initModel.tag_ids.pop(selectedTagsList.value, option.value);
          removeItemFromArray(selectedTagsList.value, option.value);
        }
      }

      handleModelChange();
    };

    // search
    const searchBar = () => {
      searchTagsList.value = search(
        availableTagsList.value,
        ["name", "slug"],
        searchQuery.value
      );
    };

    const searchCont = () => {
      searchCountryList.value = search(
        staffPageCountries.value,
        ["name", "slug"],
        searchCountry.value
      );
      handleModelChange();
    };

    // categories
    const getCategory = () => {
      for (const option of news.value.options) {
        if (option.selected) {
          const slug = option.value.split("|")[0];
          const id = option.value.split("|")[1];
          showRegions.value = slug === "uzbekistan";
          showCountry.value = slug === "world";
          videoRequired.value = slug == "media";
          initModel.sub_category = parseInt(id);
        }
        handleModelChange();
      }
    };

    const setCategory = (subCategory) => {
      for (const option of news.value.options) {
        if (option.value === `${subCategory.category.slug}|${subCategory.id}`) {
          option.selected = true;
          showRegions.value = subCategory.category.slug === "uzbekistan";
          showCountry.value = subCategory.category.slug === "world";
          videoRequired.value = subCategory.category.slug == "media";
          initModel.sub_category = subCategory.id;
        } else {
          option.selected = false;
        }
      }
    };

    // status
    const getStatus = (event) => {
      const elem = event.target;
      for (const option of elem.options) {
        if (option.selected) {
          initModel.status = option.value;
        }
      }
      handleModelChange();
    };

    // draft
    const setDraft = () => {
      initModel.draft = !initModel.draft;

      handleModelChange();
    };

    // check title brief and description
    const checkForm = () => {
      errorMessages.title = !initModel.title || !initModel.title.length === 0;
      errorMessages.brief = !initModel.brief || !initModel.brief.length === 0;
      errorMessages.description =
        !initModel.description || !initModel.description.length === 0;
    };

    const getArticleErr = (res) => {
      console.log("error: ", res);
    };

    if (editId) {
      getArticle(
        (res) => {
          for (const name in res) {
            // console.log(res.video)
            if (name === "tags") {
              for (const tag of res.tags) {
                initModel.tag_ids.push(tag.id);
              }
            } else if (name === "sub_category") {
              initModel.sub_category = res.sub_category.id;
            } else if (name === "image") {
              imageUrl.value = res.image;
              imageName.value = res.image.split("/")?.pop();
            } else if (name === "video") {
              videoUrl.value = res.video;
              videoName.value = res.video?.split("_")?.pop();
            } else if (name === "author") {
            } else {
              initModel[name] = res[name];
              // console.log(initModel);
            }
          }

          placeTags();

          pushedTags(initModel.tag_ids);

          initModel.pub_date = new Date(initModel.pub_date);

          handleModelChange();
        },
        editId,
        activeLang.value,
        getArticleErr,
        (res) => console.log(res.json())
      );
    }
    const save = (action) => {
      Object.keys(errorMessages).forEach((key) => {
        delete errorMessages[key];
      });

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });

      success.value = false;

      let slug;
      for (const option of news.value.options) {
        const optSlug = option.value.split("|")[0];
        const id = parseInt(option.value.split("|")[1]);
        if (initModel.sub_category === id) {
          slug = optSlug;
          if (
            // (slug === "uzbekistan" || slug === "world") &&
            selectedTagsList.value.length === 0
          ) {
            errorMessages.tags = ["Fill tags list"];
          } else if (slug === "uzbekistan") {
            let regionsSelected = false;
            for (const tag of selectedTagsList.value) {
              if (staffRegions.includes(tag.slug)) {
                regionsSelected = true;
              }
            }
            if (!regionsSelected) {
              errorMessages.tags = ["Select at least one region tag"];
              console.log("Select at least one region tag");
            }
          } else if (slug === "media" && !initModel.video) {
            errorMessages.video = /* i18n.t("admin.video"); */ [
              "please add video",
            ];
            return;
          } else if (slug === "world") {
            let selected = false;
            for (const tag of selectedTagsList.value) {
              if (staffCountries.includes(tag.slug)) {
                selected = true;
              }
            }
            if (!selected) {
              errorMessages.tags = ["Select at least one country tag"];
            }
          }
        }
      }
      if (errorMessages.tags) {
        return errorMessages.tags;
      }
      // append to state newArticle

      const formData = new FormData();

      for (const name in store.getters.newArticle) {
        formData.append(name, store.getters.newArticle[name]);
      }

      if (editId) {
        editArticle(
          async (res) => {
            const response = await res;

            console.log(response)

            if (response) {
              if (action === "edit") {
                router.push(
                  i18nRoute({
                    name: "EditArticle_StaffDetail",
                    params: {
                      lang: `edit-${activeLang.value}`,
                      id: response?.id,
                    },
                  })
                );
              } else {
                router.push(
                  i18nRoute(
                    { name: "NewsDetail", params: { slug: response?.url } },
                    activeLang.value
                  )
                );
              }
              if (
                !errorMessages?.title &&
                !errorMessages?.title_kr &&
                !errorMessages?.brief &&
                !errorMessages?.brief_kr &&
                !errorMessages?.description && 
                !errorMessages?.description_kr &&
                !errorMessages?.image &&
                !errorMessages?.video &&
                !errorMessages?.tags &&
                !errorMessages?.sub_category &&
                !errorMessages?.non_field_errors
              ) {
                success.value = true;
              } else {
                success.value = false;
              }
            }
          },
          editId,
          store.getters.access,
          formData,
          activeLang.value,
          async (res) => {
            // console.log(res);
            const body = await res.json();
            for (const name in body) {
              errorMessages[name] = body[name];
            }
          }
        );
      } else {
        createArticle(
          async (res) => {
            const response = await res;
            console.log(response);
            if (response) {
              if (action === "edit") {
                router.push(
                  i18nRoute({
                    name: "EditArticle_StaffDetail",
                    params: {
                      lang: `edit-${activeLang.value}`,
                      id: response?.id,
                    },
                  })
                );
                editId = response?.id;
              } else {
                router.push(
                  i18nRoute(
                    { name: "NewsDetail", params: { slug: response?.url } },
                    activeLang.value
                  )
                );
              }
              if (
                !errorMessages?.title &&
                !errorMessages?.brief &&
                !errorMessages?.description &&
                !errorMessages?.image &&
                !errorMessages?.tags &&
                !errorMessages?.sub_category &&
                !errorMessages?.non_field_errors
              ) {
                success.value = true;
              } else {
                success.value = false;
              }
            }
            handleModelChange();
          },
          store.getters.access,
          formData,
          activeLang.value,
          async (res) => {
            // console.log(res);
            const body = await res.json();
            for (const name in body) {
              errorMessages[name] = body[name];
            }
          }
        );
      }
    };

    const updateLang = (newVal) => {
      if (newVal)
        store.dispatch("getSubCategories", {
          cb: async (res) => {
            let newCat;
            for (const subCat of res) {
              if (initModel.sub_category === subCat.id) {
                newCat = subCat;
              }
            }
            if (editId) {
              await nextTick();
              setCategory(newCat);
            }
          },
          preferredLang: newVal,
        });
      store.dispatch("getTags", {
        cb: placeTags,
        preferredLang: newVal,
      });
    };

    const placeTags = () => {
      staffPageCountries.value = [];
      regionsList.value = [];
      availableTagsList.value = [];
      selectedTagsList.value = [];
      for (const tag of store.getters.tags) {
        if (editId && initModel.tag_ids.includes(tag.id)) {
          selectedTagsList.value.push(tag);
        } else if (staffCountries.includes(tag.slug)) {
          staffPageCountries.value.push(tag);
        } else if (staffRegions.includes(tag.slug)) {
          regionsList.value.push(tag);
        } else {
          availableTagsList.value.push(tag);
        }
      }
    };

    updateLang(activeLang.value);

    const categoriesMedia = ref(
      typeof window != "undefined" && Window.innerWidth <= 540
    );

    const handleModelChange = () => {
      const formattedDate = initModel.pub_date.toISOString();
      store.commit("updateNewArticle", {
        ...initModel,
        pub_date: formattedDate,
      });
    };

    return {
      activeLang,
      // image
      image,
      imageChange,
      imageUrl,
      imageName,
      imageRequired,
      // video
      videoChange,
      video,
      videoUrl,
      videoName,
      videoRequired,
      // show image or video
      mediaBar,
      showDisplayContent,
      // remove video
      removeFile,

      // model
      initModel,

      // tags
      selectedTags,
      avialableTags,
      selectedTagsList,
      availableTagsList,
      searchTagsList,
      addSelected,
      removeSelected,
      setAll,
      activeCountry,
      staffPageCountries,
      countryList,
      staffCountries,
      selectCountry,
      staffRegions,
      regionsList,
      selectRegions,
      regionsBarList,
      activeRegion,
      selected,

      // status
      getStatus,

      // draft
      setDraft,

      // show regions  or countries
      showCountry,
      showRegions,

      // search
      searchBar,
      searchQuery,
      searchCountry,
      searchCont,
      searchCountryList,

      categoriesMedia,
      getCategory,
      news,
      categories: computed(() => store.getters.subCategories),

      // user
      user: computed(() => store.getters.user),

      // ckeditor
      // editorData: BalloonEditor,
      handleModelChange,
      ...useCkeditor(),

      // err message
      errorMessages,

      // success messge
      success,

      // isMobile
      isMobile,

      // check fields
      checkForm,
      editId,
      // save news
      save,
    };
  },
};
</script>

<style lang="scss">
@import "vue3-date-time-picker/src/Vue3DatePicker/style/main.scss";
.createarticles {
  form {
    .uzLang {
      .uzLangContent {
        .description {
          .editorBlog {
            color: var(--secondary-font-color);
            width: 43.75vw;
          }
        }
      }
    }
    .anotherLang {
      .anotherLangContent {
        .description {
          .editorBlog {
            color: var(--secondary-font-color);
            width: 43.75vw;
          }
        }
      }
    }
  }
}

.dp__clear_icon {
  display: none !important;
}
.ck-rounded-corners {
  background: white !important;
  font-size: 0.728vw !important;
  line-height: 0.884vw !important;
}

.dp__input {
  font-size: 0.885vw !important;
  width: 14vw !important;
}
.dp__icon {
  width: 0.967vw !important;
  height: 0.967vw !important;
}

.dp__input_icon_pad {
  padding-left: 2vw !important;
}

@media screen and (max-width: 1366px) {
  .ck-rounded-corners {
    font-size: 3.823vw !important;
    line-height: 4.214vw !important;
  }

  .dp__input {
    font-size: 1.885vw !important;
    width: 24vw !important;
  }
  .dp__icon {
    width: 1.967vw !important;
    height: 1.967vw !important;
  }

  .dp__input_icon_pad {
    padding-left: 4vw !important;
  }
}

@media screen and(max-width: 414px) {
  .dp__input {
    font-size: 2.885vw !important;
    width: 44vw !important;
  }
  .dp__icon {
    width: 4.5vw !important;
    height: 4.5vw !important;
  }

  .dp__input_icon_pad {
    padding-left: 12vw !important;
  }
}
</style>

<style lang="scss" scoped>
.createarticles {
  background-color: rgba(245, 245, 245, 1);
  // title
  .title {
    display: flex;
    justify-content: space-between;
    .title-content {
      margin-top: 1.042vw;
      h1 {
        color: rgba(78, 101, 134, 1);
        font-size: 1.458vw;
        line-height: 1.719vw;
        font-weight: 400;
        margin-left: 2.083vw;
      }
      .border {
        width: 16.563vw;
        height: 0.104vw;
        background: rgba(78, 101, 134, 1);
      }
    }
    .editLang {
      display: flex;
      flex-direction: column;
      margin-right: 2.604vw;
      margin-top: 1.354vw;
      margin-bottom: 1.354vw;
      .row {
        display: flex;
        h3 {
          font-size: 0.938vw;
          line-height: 1.094vw;
          font-weight: 400;
          color: rgba(109, 109, 109, 1);
          span {
            color: rgba(69, 69, 69, 1);
            font-weight: 500;
          }
        }
        .preferredLang {
          margin-left: 0.26vw;
          color: rgba(108, 143, 186, 1);
          font-size: 0.938vw;
          line-height: 1.094vw;
          font-weight: 400;
          cursor: pointer;
          outline: none;
          background-color: transparent;
          .border {
            width: 100%;
            height: 1px;
            background: rgba(108, 143, 186, 1);
          }
        }
      }
      p {
        font-size: 0.729vw;
        line-height: 0.885vw;
        font-weight: 400;
        color: rgba(69, 69, 69, 0.5);
        text-align: left;
        width: 25vw;
        margin-top: 0.521vw;
      }
    }
  }

  .error-messages {
    display: flex;
    align-items: center;
    background: rgba(255, 231, 231, 1);
    width: 90%;
    margin-left: 2vw;
    margin-top: 1.823vw;
    padding: 0.521vw 0;
    h2 {
      font-size: 1.042vw;
      line-height: 1.25vw;
      font-weight: 400;
      color: rgba(210, 0, 1, 1);
      margin-left: 0.781vw;
    }
    img {
      background: transparent;
      padding-left: 0.781vw;
      width: 1.875vw;
      height: 1.302vw;
    }
  }
  .warning {
    display: flex;
    align-items: center;
    background: rgba(255, 253, 215, 1);
    width: 90%;
    margin-left: 2vw;
    margin-top: 1.823vw;
    padding: 0.521vw 0;
    img {
      background: transparent;
      padding-left: 0.781vw;
      width: 2.375vw;
      height: 1.402vw;
    }
    h2 {
      font-size: 1.042vw;
      line-height: 1.25vw;
      font-weight: 400;
      color: rgba(228, 182, 18, 1);
      margin-left: 0.781vw;
    }
  }

  .success {
    display: flex;
    align-items: center;
    background: #f3ffe4;
    width: 90%;
    margin-left: 2vw;
    margin-top: 1.823vw;
    padding: 0.521vw 0;
    h2 {
      font-size: 1.042vw;
      line-height: 1.25vw;
      font-weight: 400;
      color: rgba(4, 167, 1, 1);
      margin-left: 0.781vw;
    }
    i {
      color: #04a701;
      font-size: 1.771vw;
      font-weight: 900;
      padding-left: 0.781vw;
    }
  }

  // content-margin
  form {
    padding-left: 2.083vw;
    h2 {
      font-size: 0.938vw;
      line-height: 1.094vw;
      font-weight: 500;
      color: rgba(69, 69, 69, 1);
      margin-right: 1.042vw;
    }
    .uzLang {
      h1 {
        font-size: 1.25vw;
        line-height: 1.458vw;
        font-weight: 400;
        color: rgba(44, 84, 141, 1);
        margin-top: 2.083vw;
        margin-bottom: 2.604vw;
        margin-left: 4.167vw;
        span {
          border-bottom: 1px solid rgba(44, 84, 141, 1);
        }
      }
      .uzLangContent {
        // table
        .table {
          display: grid;
          grid-template-columns: repeat(2, auto);
          margin-bottom: 2.083vw;
          margin-top: 2.865vw;

          h3 {
            font-size: 0.729vw;
            line-height: 0.885vw;
            font-weight: 500;
            color: rgba(210, 0, 1, 1);
            margin-bottom: 0.26vw;
          }
          h2 {
            margin-right: 1.563vw;
          }
          .text {
            display: flex;
            width: max-content;

            h4 {
              font-size: 0.729vw;
              line-height: 0.885vw;
              font-weight: 500;
              color: rgba(210, 0, 1, 1);
              margin-left: 8.7vw;
            }

            .text-input {
              display: flex;
              flex-direction: column;
              position: relative;
              h3 {
                position: absolute;
                left: 0;
                top: -1vw;
              }

              input {
                width: 17.708vw;
                height: 1.607vw;
                padding: 0 0.521vw;
                outline: none;
                border: 1px solid rgba(115, 115, 115, 1);
                font-size: 0.729vw;
                line-height: 0.885vw;
              }
            }
          }
          .brief {
            display: flex;
            .brief-input {
              display: flex;
              flex-direction: column;
              position: relative;
              h3 {
                position: absolute;
                left: 0;
                top: -1vw;
              }
              textarea {
                width: 28.438vw;
                height: 7.813vw;
                padding: 0.521vw;
                outline: none;
                border: 1px solid rgba(115, 115, 115, 1);
                font-size: 0.729vw;
                line-height: 0.885vw;
              }
            }
          }
        }
        // description
        .description {
          display: flex;
          h2 {
            margin-right: 2.24vw;
          }
          .editor {
            display: flex;
            flex-direction: column;
            position: relative;

            h3 {
              position: absolute;
              left: 0;
              top: -1vw;
              font-size: 0.729vw;
              line-height: 0.885vw;
              font-weight: 500;
              color: rgba(210, 0, 1, 1);
            }
          }
        }
      }
    }
    .anotherLang {
      h1 {
        font-size: 1.25vw;
        line-height: 1.458vw;
        font-weight: 400;
        color: rgba(44, 84, 141, 1);
        margin-top: 2.083vw;
        margin-bottom: 2.604vw;
        margin-left: 4.167vw;
        span {
          border-bottom: 1px solid rgba(44, 84, 141, 1);
        }
      }
      .anotherLangContent {
        // table
        .table {
          display: grid;
          grid-template-columns: repeat(2, auto);
          margin-bottom: 2.083vw;
          margin-top: 2.865vw;

          h3 {
            font-size: 0.729vw;
            line-height: 0.885vw;
            font-weight: 500;
            color: rgba(210, 0, 1, 1);
            margin-bottom: 0.26vw;
          }
          h2 {
            margin-right: 1.563vw;
          }
          .text {
            display: flex;
            width: max-content;

            h4 {
              font-size: 0.729vw;
              line-height: 0.885vw;
              font-weight: 500;
              color: rgba(210, 0, 1, 1);
              margin-left: 8.7vw;
            }

            .text-input {
              display: flex;
              flex-direction: column;
              position: relative;
              h3 {
                position: absolute;
                left: 0;
                top: -1vw;
              }

              input {
                width: 17.708vw;
                height: 1.607vw;
                padding: 0 0.521vw;
                outline: none;
                border: 1px solid rgba(115, 115, 115, 1);
                font-size: 0.729vw;
                line-height: 0.885vw;
              }
            }
          }
          .brief {
            display: flex;
            .brief-input {
              display: flex;
              flex-direction: column;
              position: relative;
              h3 {
                position: absolute;
                left: 0;
                top: -1vw;
              }
              textarea {
                width: 28.438vw;
                height: 7.813vw;
                padding: 0.521vw;
                outline: none;
                border: 1px solid rgba(115, 115, 115, 1);
                font-size: 0.729vw;
                line-height: 0.885vw;
              }
            }
          }
        }
        // description
        .description {
          display: flex;
          h2 {
            margin-right: 2.24vw;
          }
          .editor {
            display: flex;
            flex-direction: column;
            position: relative;

            h3 {
              position: absolute;
              left: 0;
              top: -1vw;
              font-size: 0.729vw;
              line-height: 0.885vw;
              font-weight: 500;
              color: rgba(210, 0, 1, 1);
            }
          }
        }
      }
    }
    // files
    .files {
      display: grid;
      grid-template-columns: 15vw 15vw 17vw;
      grid-gap: 8vw;
      margin-top: 2.083vw;
      .files-flex {
        display: grid;
        grid-template-rows: 4vw 3vw 3vw 0.5vw;
        align-items: center;
        .files-flex-content {
          display: flex;
          margin-bottom: 0.365vw;
          #video {
            h2 {
              font-weight: 300;
            }
          }
          h2 {
            font-weight: 600;
          }
          .files-input {
            display: flex;
            flex-direction: column;
            position: relative;
            h3 {
              font-size: 0.629vw;
              line-height: 0.885vw;
              font-weight: 500;
              color: rgba(210, 0, 1, 1);
              position: absolute;
              left: 0;
              top: -1vw;
              width: 10vw;
            }
            input {
              width: 7.031vw;
              height: 1.51vw;
              font-size: 0.833vw;
              line-height: 0.99vw;
              font-weight: 300;
              position: relative;
              border: 1px solid #737373;
              &:after {
                content: attr(label);
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                color: black;
                cursor: pointer;
                width: 100%;
                height: 100%;
                background: white;
                display: flex;
                justify-content: center;
                align-items: center;
              }
            }
          }
        }

        h3 {
          font-size: 0.729vw;
          line-height: 0.855vw;
          font-weight: 400;
          color: rgba(69, 69, 69, 1);
          span {
            color: rgba(77, 114, 166, 1);
            font-weight: 300;
          }
        }
        button {
          background: white;
          width: 7.031vw;
          height: 1.51vw;
          font-size: 0.833vw;
          line-height: 0.99vw;
          font-weight: 300;
          outline: none;
          cursor: pointer;
          border: 1px solid #737373;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .display {
        .display-content {
          p {
            color: #121212;
          }
        }
        .image {
          width: 12.136vw;
          height: 9.115vw;
          object-fit: cover;
        }
      }
    }

    .categories {
      // tags-blog
      display: grid;
      grid-template-areas:
        "h2TagTitle avialable arrows selectedTags country"
        "h3ShortCut h3ShortCut h3ShortCut h3ShortCut h3ShortCut"
        "newsLeft newsLeft status status checkbox"
        "date date date date date";
      grid-template-columns: 2.5vw 17.5vw 1.5vw 17.5vw 17.5vw;
      grid-gap: 1vw;
      align-items: center;
      position: relative;
      .tegi {
        grid-area: h2TagTitle;
        width: max-content;
        position: relative;
        top: -7.5vw;
        h2 {
          font-size: 0.938vw;
          line-height: 1.098vw;
          font-weight: 500;
          color: rgba(69, 69, 69, 1);
        }
      }
      h3 {
        font-size: 0.729vw;
        line-height: 0.855vw;
        font-weight: 300;
        color: rgba(146, 146, 146, 1);
        margin-top: 0.5vw;
        margin-bottom: 3.125vw;
        margin-left: 3.646vw;
        grid-area: h3ShortCut;
      }

      .avialableSection {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        grid-area: avialable;
        .avialableTags {
          width: 100%;
          border: 1px solid rgba(69, 69, 69, 1);
          .avialableTitle {
            width: 100%;
            height: 1.771vw;
            display: flex;
            align-items: center;
            background-color: rgba(234, 234, 234, 1);
            h1 {
              font-size: 0.833vw;
              line-height: 0.977vw;
              font-weight: 300;
              margin-left: 0.521vw;
              color: rgba(69, 69, 69, 1);
            }
          }
          select {
            width: 100%;
            height: 10.26vw;
            padding-bottom: 0.521vw;
            padding-top: 0.521vw;
            outline: none;
            background-color: #fff;
            option {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              margin-bottom: 0.208vw;
              margin-left: 0.625vw;
              background-color: transparent;
              outline: none;
              font-size: 0.938vw;
              font-weight: 300;
              color: black;
              cursor: pointer;
            }
          }

          .avialableSearch {
            display: flex;
            align-items: center;
            background-color: #fff;
            border-top: 1px solid rgba(69, 69, 69, 1);
            border-bottom: 1px solid rgba(69, 69, 69, 1);
            input {
              width: 100%;
              height: 1.407vw;
              margin-top: 0.521vw;
              margin-bottom: 0.781vw;
              margin-right: 0.781vw;
              padding: 0 0.521vw;
              outline: none;
              border: 1px solid rgba(69, 69, 69, 1);
              font-size: 0.833vw;
              line-height: 0.99vw;
            }
            i {
              margin-left: 0.886vw;
              margin-right: 0.886vw;
              margin-top: 0.521vw;
              margin-bottom: 0.781vw;
              cursor: pointer;
              color: rgba(69, 69, 69, 1);
              font-weight: 300;
              font-size: 1.5vw;
            }
          }
        }
        .selectAll {
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          color: rgba(69, 69, 69, 1);
          background-color: transparent;
          outline: none;
          gap: 0.26vw;
          margin-top: 0.521vw;
          span {
            font-size: 0.833vw;
            line-height: 0.99vw;
          }
          .icon {
            width: 0.729vw;
            height: 0.729vw;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #454545;
            i {
              color: var(--primary-font-color);
              font-size: 0.521vw;
              margin-left: 0.1vw;
              &:before {
                content: "\f054";
              }
            }
          }
        }
      }

      .arrows {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 2.604vw;
        width: 1.51vw;
        height: 3.229vw;
        background-color: rgba(234, 234, 234, 1);
        position: relative;
        grid-area: arrows;
        margin-left: auto;
        margin-right: auto;
        .arrowRight,
        .arrowLeft {
          i {
            background-color: rgba(196, 196, 196, 1);
            width: 0.99vw;
            height: 0.99vw;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0.521vw;
            cursor: pointer;
            border-radius: 50%;
            font-size: 0.625vw;
          }
          i:hover {
            background-color: rgba(77, 114, 166, 1);
          }
        }

        .arrowRight {
          i {
            &:before {
              content: "\f054";
            }
          }
        }
        .arrowLeft {
          margin-top: 0.417vw;
          i {
            &:before {
              content: "\f053";
            }
          }
        }
      }

      .selectedTags {
        display: flex;
        flex-direction: column;
        justify-content: center;
        grid-area: selectedTags;
        // margin-left: 0.938rem;
        position: relative;
        h4 {
          font-size: 0.829vw;
          line-height: 1.04vw;
          font-weight: 500;
          color: rgba(210, 0, 1, 1);
          position: absolute;
          left: 0;
          top: -1.3vw;
        }
        .selectedSection {
          width: 100%;
          .selectedTitle {
            background-color: rgba(77, 114, 166, 1);
            height: 1.771vw;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            h1 {
              margin-left: 0.521vw;
              color: #fff;
              font-size: 0.833vw;
              line-height: 0.99vw;
              font-weight: 300;
            }
          }
          select {
            width: 100%;
            padding-top: 0.521vw;
            outline: none;
            height: 13.6vw;
            background: white;
            color: black;
            option {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              margin-bottom: 0.208vw;
              margin-left: 0.625vw;
              background-color: transparent;
              outline: none;
              cursor: pointer;
              font-size: 0.938vw;
              font-weight: 300;
            }
          }
        }
        .deleteAll {
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          width: max-content;
          color: rgba(69, 69, 69, 1);
          background-color: transparent;
          outline: none;
          margin-left: auto;
          margin-right: auto;
          gap: 0.26vw;
          span {
            font-size: 0.833vw;
            line-height: 0.99vw;
          }

          .icon {
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #454545;
            width: 0.729vw;
            height: 0.729vw;
            border-radius: 50%;
            margin-right: 0.26vw;
            i {
              color: var(--primary-font-color);
              font-size: 0.521vw;
              &:before {
                content: "\f053";
              }
            }
          }
        }
      }
      .regionsBar {
        width: 100%;
        grid-area: country;
        position: relative;
        h5 {
          font-size: 0.829vw;
          line-height: 1.04vw;
          font-weight: 500;
          color: rgba(210, 0, 1, 1);
          position: absolute;
          left: 1vw;
          top: -1.3vw;
        }
        .regionsSelect {
          height: 16.5vw;
          width: 100%;
          margin-left: 1vw;
          display: flex;
          flex-direction: column;
          .regionsTitle {
            background-color: rgba(77, 114, 166, 1);
            height: 1.771vw;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            h2 {
              margin-left: 0.521vw;
              color: #fff;
              font-size: 0.833vw;
              line-height: 0.99vw;
              font-weight: 300;
            }
          }
          select {
            height: 100%;
            padding-top: 0.521vw;
            outline: none;
            height: 16vw;
            option {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              margin-bottom: 0.208vw;
              margin-left: 0.625vw;
              outline: none;
              font-size: 0.938vw;
              font-weight: 300;
            }
          }
          button {
            // width: 6.146vw;
            // height: 2.031vw;
            // background: #6c8fba;
            // color: white;
            // cursor: pointer;
            // margin-top: 0.521vw;
            // margin-left: auto;
            // margin-right: auto;
            // font-size: 0.833vw;
            // line-height: 0.99vw;
            display: none;
          }
          p {
            font-size: 0.829vw;
            line-height: 0.885vw;
            font-weight: 300;
            color: rgba(146, 146, 146, 1);
            margin-left: auto;
            margin-right: auto;
            margin-top: 0.26vw;
            // color: black;
            span {
              font-weight: 600;
            }
          }
        }
      }
      .country {
        display: flex;
        flex-direction: column;
        align-items: center;
        grid-area: country;
        margin-left: 1vw;
        position: relative;
        h5 {
          font-size: 0.829vw;
          line-height: 1.04vw;
          font-weight: 500;
          color: rgba(210, 0, 1, 1);
          position: absolute;
          left: 0;
          top: -1.3vw;
        }
        .countries {
          border: 1px solid rgba(69, 69, 69, 1);
          width: 100%;
          .countryTitle {
            width: 100%;
            height: 1.771vw;
            display: flex;
            align-items: center;
            background: rgba(234, 234, 234, 1);
            h1 {
              font-size: 0.833vw;
              line-height: 0.977vw;
              font-weight: 300;
              margin-left: 0.521vw;
              color: rgba(69, 69, 69, 1);
            }
          }
          .countrySearch {
            display: flex;
            align-items: center;
            background: #fff;
            border-top: 1px solid rgba(69, 69, 69, 1);
            border-bottom: 1px solid rgba(69, 69, 69, 1);
            input {
              width: 100%;
              height: 1.407vw;
              margin-top: 0.521vw;
              margin-bottom: 0.781vw;
              margin-right: 0.781vw;
              padding: 0 0.521vw;
              outline: none;
              border: 1px solid rgba(69, 69, 69, 1);
              font-size: 0.833vw;
              line-height: 0.99vw;
            }
            i {
              margin-left: 0.886vw;
              margin-right: 0.886vw;
              margin-top: 0.521vw;
              margin-bottom: 0.781vw;
              cursor: pointer;
              color: #454545;
              font-weight: 400;
              font-size: 1.302vw;
            }
          }
          select {
            height: 10.26vw;
            width: 100%;
            outline: none;
            option {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              margin: 0.208vw;
              margin-left: 0.625vw;
              background: transparent;
              outline: none;
              font-size: 0.938vw;
              font-weight: 300;
            }
          }
        }
        .selectCountry {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-top: 0.521vw;
          button {
            // width: 6.146vw;
            // height: 2.031vw;
            // background: #6c8fba;
            // color: white;
            // cursor: pointer;
            // margin-left: auto;
            // margin-right: auto;
            // font-size: 0.833vw;
            // line-height: 0.99vw;
            display: none;
          }
          p {
            font-size: 0.829vw;
            line-height: 0.885vw;
            font-weight: 300;
            color: rgba(146, 146, 146, 1);
            // color: black;
            span {
              font-weight: 600;
            }
          }
        }
      }
      .news-left {
        display: flex;
        flex-direction: column;
        align-items: center;
        grid-area: newsLeft;
        // margin-bottom: 2.865vw;
        width: max-content;
        h3 {
          font-size: 0.729vw;
          line-height: 0.885vw;
          font-weight: 500;
          color: rgba(210, 0, 1, 1);
          margin-bottom: 0.26vw;
          width: max-content;
          margin-left: auto;
          margin-top: 0;
        }
        .news {
          display: flex;
          align-items: center;
          // justify-content: space-around;
          select {
            background-color: #fff;
            // padding: 0.625rem;
            font-size: 0.833vw;
            line-height: 0.99vw;
            font-weight: 300;
            color: rgba(18, 18, 18, 1);
            outline: none;
            border: 1px solid #737373;
            height: 1.667vw;
            outline: none;
            width: 7.031vw;
            option {
              font-size: 0.833vw;
              line-height: 0.99vw;
              font-weight: 300;
              color: rgba(18, 18, 18, 1);
              background-color: white;
            }
          }
        }
      }
      .status {
        grid-area: status;
        display: flex;
        align-items: center;
        width: 16.844vw;
        height: 1.719vw;
        select {
          width: 7.813vw;
          height: 1.719vw;
          background-color: var(--primary-font-color);
          font-size: 0.833vw;
          line-height: 0.99vw;
          font-weight: 300;
          color: rgba(18, 18, 18, 1);
          outline: none;
          border: 1px solid #737373;
          option {
            font-size: 0.833vw;
            line-height: 0.99vw;
            font-weight: 300;
            color: rgba(18, 18, 18, 1);
            background-color: white;
          }
        }
      }
      .check {
        grid-area: checkbox;
        display: flex;
        justify-content: center;
        align-items: center;
        input {
          width: 1vw;
          height: 1vw;
        }
        label {
          position: relative;
          cursor: pointer;
          color: rgba(18, 18, 18, 1);
          font-size: 0.833vw;
          line-height: 0.99vw;
          font-weight: 300;
          margin-left: 0.781vw;
        }
      }
      .date {
        grid-area: date;
        display: flex;
        flex-direction: column;
        margin-top: 3vw;
        height: 7vw;
        .calendar {
          display: flex;
        }
        h3 {
          grid-area: explanation;
          // margin: 0;
          margin-left: 0;
          margin-top: 2rem;
          margin-bottom: 0;
        }
      }
    }
  }

  // links
  .links {
    background-color: rgba(238, 238, 238, 1);
    width: 100%;
    .mr {
      margin-right: 1.302vw;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 0.521vw 0;
      padding-bottom: 1.563rem;
      .link {
        color: #fff;
        background-color: #6c8fba;
        margin-left: 1.302vw;
        padding: 0.781vw;
        font-size: 0.833vw;
        line-height: 0.99vw;
        &:hover,
        &:focus,
        &:active {
          background-color: rgba(44, 84, 141, 1);
          transition: all 0.5s;
        }
      }
    }
  }
}

// media
@media screen and (max-width: 1366px) {
  .createarticles {
    margin-top: 10vw;
    .title {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-top: 1.302vw;
      .title-content {
        display: flex;
        flex-direction: column;
        margin-top: 1.302vw;
        margin-bottom: 1.302vw;
        h1 {
          font-size: 3.385vw;
          padding-left: 2.06vw;
        }
        .border {
          width: 37.37vw;
          height: 0.26vw;
          margin-top: 1.302vw;
        }
      }
      .editLang {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .row {
          width: 62.76vw;
          h3 {
            font-size: 2.344vw;
            line-height: 2.865vw;
          }
          .preferredLang {
            font-size: 2.344vw;
            line-height: 2.865vw;
          }
        }
        p {
          font-size: 1.823vw;
          line-height: 2.214vw;
          width: 62vw;
        }
      }
    }

    .file {
      .sendFile {
        font-size: 1.823vw;
        line-height: 2.214vw;
      }
    }

    .error-messages {
      h2 {
        font-size: 2.083vw;
        line-height: 2.474vw;
      }
    }
    .warning {
      h2 {
        font-size: 2.083vw;
        line-height: 2.474vw;
      }
      img {
        width: 6vw;
        height: 4vw;
      }
    }

    .success {
      h2 {
        font-size: 2.083vw;
        line-height: 2.474vw;
      }
      i {
        font-size: 3.606vw;
      }
    }

    form {
      padding-left: 3vw;
      margin-top: 10vw;
      h2 {
        font-size: 2.083vw;
        line-height: 2.474vw;
      }

      .uzLang {
        h1 {
          font-size: 2.865vw;
          line-height: 3.385vw;
          margin-left: 0;
        }
        h2 {
          font-size: 2.474vw;
          line-height: 2.865vw;
        }
        .uzLangContent {
          display: flex;
          align-items: center;
          flex-direction: column;
          .table {
            display: flex;
            flex-direction: column;
            h3 {
              font-size: 1.823vw;
              line-height: 2.214vw;
            }
            .text {
              display: flex;
              flex-direction: column;
              position: relative;
              margin-bottom: 3.906vw;
              h3 {
                position: absolute;
                right: 0;
                top: -1.2vw;
                font-size: 1.823vw;
                line-height: 2.214vw;
                width: 100%;
                text-align: right;
              }
              .text-input {
                display: flex;
                flex-direction: column;
                input {
                  margin-top: 1.302vw;
                  width: 73.568vw;
                  height: 4.557vw;
                  font-size: 2.083vw;
                  line-height: 2.474vw;
                }
              }
            }
            .brief {
              display: flex;
              flex-direction: column;
              position: relative;
              width: max-content;

              .brief-input {
                display: flex;
                h3 {
                  position: absolute;
                  right: 0;
                  top: -1.2vw;
                  font-size: 1.823vw;
                  line-height: 2.214vw;
                  width: 100%;
                  text-align: right;
                }
                textarea {
                  margin-top: 1.302vw;
                  width: 73.568vw;
                  height: 4.557vw;
                  font-size: 2.083vw;
                  line-height: 2.474vw;
                }
              }
            }
          }
          .description {
            display: flex;
            flex-direction: column;
            position: relative;
            width: max-content;

            h2 {
              margin-bottom: 1.302vw;
            }
            .editor {
              display: flex;

              h3 {
                position: absolute;
                right: 0;
                top: -2.4vw;
                font-size: 1.823vw;
                line-height: 2.214vw;
                width: 100%;
                text-align: right;
              }
              .editorBlog {
                width: 90vw;
              }
            }
          }
        }
      }

      .anotherLang {
        h1 {
          font-size: 2.865vw;
          line-height: 3.385vw;
          margin-left: 0;
        }
        h2 {
          font-size: 2.474vw;
          line-height: 2.865vw;
        }
        .anotherLangContent {
          display: flex;
          align-items: center;
          flex-direction: column;
          .table {
            display: flex;
            flex-direction: column;
            h3 {
              font-size: 1.823vw;
              line-height: 2.214vw;
            }
            .text {
              display: flex;
              flex-direction: column;
              position: relative;
              margin-bottom: 3.906vw;
              .text-input {
                display: flex;
                flex-direction: column;
                input {
                  margin-top: 1.302vw;
                  width: 73.568vw;
                  height: 4.557vw;
                  font-size: 2.083vw;
                  line-height: 2.474vw;
                }
                h3 {
                  position: absolute;
                  right: 0;
                  top: -2.8vw;
                  font-size: 2.823vw;
                  line-height: 2.214vw;
                  width: 100%;
                  text-align: right;
                }
              }
            }
            .brief {
              display: flex;
              flex-direction: column;
              position: relative;
              width: max-content;

              .brief-input {
                display: flex;
                h3 {
                  position: absolute;
                  right: 0;
                  top: -1.2vw;
                  font-size: 1.823vw;
                  line-height: 2.214vw;
                  width: 100%;
                  text-align: right;
                }
                textarea {
                  margin-top: 1.302vw;
                  width: 73.568vw;
                  height: 4.557vw;
                  font-size: 2.083vw;
                  line-height: 2.474vw;
                }
              }
            }
          }
          .description {
            display: flex;
            flex-direction: column;
            position: relative;
            width: max-content;

            h2 {
              margin-bottom: 1.302vw;
            }
            .editor {
              display: flex;

              h3 {
                position: absolute;
                right: 0;
                top: -2.4vw;
                font-size: 1.823vw;
                line-height: 2.214vw;
                width: 100%;
                text-align: right;
              }
              .editorBlog {
                width: 90vw;
              }
            }
          }
        }
      }

      .files {
        display: grid;
        grid-template-columns: auto;
        gap: 0;
        grid-template-rows: 24vw;
        position: relative;
        margin-bottom: 5.661vw;
        .files-flex {
          display: grid;
          grid-template-areas:
            "content content"
            "moment moment";
          align-items: flex-start;
          width: 50vw;
          position: relative;
          margin-top: 4rem;
          .files-flex-content {
            grid-area: content;
            display: flex;
            gap: 0.521vw;
            h2 {
              margin-right: 5vw;
            }

            .files-input {
              display: flex;
              h3 {
                font-size: 1.123vw;
                line-height: 2.214vw;
                margin-left: 0;
                margin-top: 0;
                position: absolute;
                left: 0;
                top: -2vw;
                width: 100%;
              }
              input {
                width: 21.578vw;
                height: 4.036vw;
                font-size: 2.083vw;
                line-height: 2.474vw;
              }
            }
          }
          h3 {
            grid-area: moment;
            font-size: 1.823vw;
            line-height: 2.214vw;
            margin-top: 2vw;
          }

          button {
            margin-top: 6vw;
            width: 17.578vw;
            height: 4.036vw;
            font-size: 2.083vw;
            line-height: 2.474vw;
          }
        }
        .display {
          .image {
            position: absolute;
            right: 9.5vw;
            top: 15.5vw;
            width: 32.552vw;
            height: 24.479vw;
          }
        }
      }

      .categories {
        display: grid;
        grid-template-areas:
          "h2TagTitle h4TagTitle h4TagTitle"
          "avialable arrow selectedTags"
          "newsLeft newsLeft status"
          "date checkbox checkbox"
          "country country .";
        grid-template-columns: 38.281vw 10vw 38.281vw;
        align-items: flex-start;
        margin-left: 2vw;
        .tegi {
          top: 0;

          h2 {
            font-size: 2.344vw;
            line-height: 2.865vw;
          }
        }
        h3 {
          display: none;
        }

        .avialableSection {
          height: 100%;
          margin-right: 2vw;
          .avialableTags {
            .avialableTitle {
              height: 4.297vw;
              h1 {
                font-size: 2.083vw;
                line-height: 2.474vw;
              }
            }
            .avialableSearch {
              display: flex;
              justify-content: center;
              align-items: center;
              input {
                width: 30.505vw;
                height: 3.516vw;
                margin-right: 1.302vw;
                font-size: 2.083vw;
                line-height: 2.474vw;
                font-weight: 300;
              }
              i {
                font-size: 3vw;
                color: rgba(69, 69, 69, 1);
                margin-left: 2.214vw;
                margin-right: 2.5vw;
                font-weight: 300;
              }
            }
            select {
              height: 21.3vw;
              option {
                font-size: 2.083vw;
                line-height: 2.474vw;
                margin-left: 1.563vw;
                margin-bottom: 0.521vw;
                font-weight: 400;
              }
            }
          }
          .selectAll {
            span {
              font-size: 2.344vw;
              line-height: 2.865vw;
            }
            .icon {
              width: 2.083vw;
              height: 2.083vw;
              display: flex;
              align-items: center;
              justify-content: center;
              i {
                font-size: 1.2vw;
              }
            }
          }
        }

        .arrows {
          grid-area: arrow;
          top: 50%;
          transform: translateY(-50%);
          width: 5vw;
          height: 10vw;
          .arrowRight,
          .arrowLeft {
            i {
              width: 2vw;
              height: 2vw;
              font-size: 1.5vw;
            }
          }
        }
        .selectedTags {
          width: 38.281vw;
          h4 {
            font-size: 1.8vw;
            line-height: 2.474vw;
            width: 38.281vw;
            left: 0;
            top: -2.5vw;
          }
          .selectedSection {
            height: 100%;
            .selectedTitle {
              height: 4.297vw;
              h1 {
                font-size: 2.083vw;
                line-height: 2.474vw;
              }
            }
            select {
              height: 27.48vw;
              option {
                font-size: 2.083vw;
                line-height: 2.474vw;
                margin-left: 1.563vw;
                margin-bottom: 0.521vw;
                font-weight: 400;
              }
            }
          }
          .deleteAll {
            span {
              font-size: 2.344vw;
              line-height: 2.865vw;
            }
            .icon {
              width: 2.083vw;
              height: 2.083vw;
              display: flex;
              align-items: center;
              justify-content: center;
              margin: 0;
              i {
                font-size: 1.2vw;
              }
            }
          }
        }

        .news-left {
          margin-top: 10vw;
          h3 {
            display: block;
            font-size: 2.083vw;
            margin-bottom: 1vw;
          }
          .news {
            display: flex;
            justify-content: space-between;

            select {
              width: 25.998vw;
              height: 4.297vw;
              font-size: 2.083vw;
              line-height: 2.474vw;
              option {
                font-size: 2.083vw;
                line-height: 2.474vw;
              }
            }
          }
        }

        .status {
          width: 40.885vw;
          height: 4.297vw;
          margin-top: 10vw;
          select {
            width: 23.698vw;
            height: 4.297vw;
            font-size: 2.083vw;
            line-height: 2.474vw;
            option {
              font-size: 2.083vw;
              line-height: 2.474vw;
            }
          }
        }

        .check {
          align-items: center;
          margin-top: 7.6vw;
          input {
            width: 2vw;
            height: 2vw;
          }
          label {
            font-size: 2.083vw;
            line-height: 2.474vw;
          }
        }

        .date {
          width: 100%;
          .calendar {
            display: flex;
            flex-direction: column;
          }
          h2 {
            margin-bottom: 1vw;
            font-size: 1.823vw;
            line-height: 2.214vw;
          }
        }

        .country {
          width: 38.281vw;
          height: 100%;
          margin-bottom: 6.51vw;
          margin-left: 26vw;

          h5 {
            font-size: 1.8vw;
            line-height: 2.474vw;
            width: 38.281vw;
            left: 0;
            top: -3vw;
          }
          .countries {
            .countryTitle {
              height: 4.297vw;
              h1 {
                font-size: 2.083vw;
                line-height: 2.474vw;
              }
            }
            .countrySearch {
              display: flex;
              justify-content: center;
              align-items: center;
              input {
                width: 30.505vw;
                height: 3.516vw;
                margin-right: 1.302vw;
                font-size: 2.083vw;
                line-height: 2.474vw;
                font-weight: 300;
              }
              i {
                font-size: 3vw;
                color: rgba(69, 69, 69, 1);
                margin-left: 2.214vw;
                margin-right: 2.474vw;
                font-weight: 300;
              }
            }
            select {
              font-size: 2.083vw;
              line-height: 2.474vw;
              height: 21.3vw;
              option {
                font-size: 2.083vw;
                line-height: 2.474vw;
                margin-left: 1.563vw;
                margin-bottom: 0.521vw;
                font-weight: 400;
              }
            }
          }
          .selectCountry {
            display: flex;
            flex-direction: column;
            button {
              width: 15.365vw;
              height: 5.078vw;
              margin-bottom: 0.651vw;
              background: #6c8fba;
              color: white;
              display: block;
            }
            p {
              font-size: 1.823vw;
              line-height: 2.214vw;
            }
          }
        }

        .regionsBar {
          width: 28.281vw;
          height: 100%;
          margin-left: 30vw;
          margin-bottom: 5vw;
          h5 {
            font-size: 1.8vw;
            line-height: 2.474vw;
            width: 38.281vw;
            left: 0;
            top: -3vw;
          }
          .regionsSelect {
            height: 100%;
            margin-left: 0;
            .regionsTitle {
              height: 4.297vw;
              h2 {
                font-size: 2.083vw;
                line-height: 2.474vw;
              }
            }
            select {
              height: 27.48vw;
              option {
                font-size: 2.083vw;
                line-height: 2.474vw;
                margin-left: 1.563vw;
                margin-bottom: 0.521vw;
                font-weight: 400;
              }
            }
            button {
              width: 15.365vw;
              height: 5.078vw;
              margin-top: 1.321vw;
              background: #6c8fba;
              color: white;
              margin-left: auto;
              margin-right: auto;
              display: block;
            }
            p {
              font-size: 1.823vw;
              line-height: 2.214vw;
              margin-top: 0.651vw;
            }
          }
        }
      }

      .links {
        background: transparent;
        .mr {
          display: flex;
          flex-direction: column;
          align-items: center;
          .link {
            font-size: 2.604vw;
            line-height: 3.125vw;
            font-weight: 400;
            // padding: 1.5vw;
            width: 55.208vw;
            height: 6.641vw;
            &:nth-child(2) {
              width: 23.047vw;
              margin-top: 3.906vw;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 414px) {
  .createarticles {
    margin-top: 15vw;
    .title {
      .title-content {
        h1 {
          font-size: 5.867vw;
          line-height: 6.933vw;
          margin-left: 6vw;
        }
        .border {
          width: 66.133vw;
          height: 0.533vw;
        }
      }
      .editLang {
        margin-top: 4vw;
        .row {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          h3 {
            font-size: 4.267vw;
            line-height: 5.067vw;
            width: 45.333vw;
            margin-left: 4vw;
          }
          .preferredLang {
            margin-right: 4vw;
            font-size: 4.267vw;
            line-height: 5.067vw;
          }
        }
        p {
          width: 100%;
          font-size: 3.733vw;
          line-height: 4.533vw;
          padding: 0 4vw;
          margin-top: 2.667vw;
          margin-bottom: 10.667vw;
        }
      }
    }

    .file {
      display: flex;
      flex-direction: column;
      align-items: center;

      .sendFile {
        margin-bottom: 2.667vw;
        font-size: 4.267vw;
        line-height: 5.067vw;
      }
    }

    .error-messages {
      padding: 2vw 1vw;
      h2 {
        font-size: 3.733vw;
        line-height: 4.533vw;
      }
      img {
        margin-left: 3.2vw;
      }
    }
    .warning {
      padding: 2vw 1vw;
      h2 {
        font-size: 3.733vw;
        line-height: 4.533vw;
      }
      img {
        margin-left: 3.2vw;
        width: 6vw;
        height: 5vw;
      }
    }

    .success {
      padding: 2vw 1vw;
      h2 {
        font-size: 3.733vw;
        line-height: 4.533vw;
      }
      i {
        font-size: 8vw;
        margin-right: 2.667vw;
        margin-left: 3.2vw;
      }
    }

    form {
      h2 {
        font-size: 4vw;
        line-height: 4vw;
      }
      .uzLang {
        h1 {
          font-size: 5.867vw;
          line-height: 6.933vw;
        }
        .uzLangContent {
          align-items: flex-start;
          .table {
            h2 {
              font-size: 4.8vw;
              line-height: 5.6vw;
            }
            .text {
              .text-input {
                h3 {
                  font-size: 3.733vw;
                  line-height: 4.533vw;
                  top: -4vw;
                }
                input {
                  width: 90.667vw;
                  height: 7.2vw;

                  font-size: 4.267vw;
                  line-height: 5.067vw;
                }
              }
            }
            .brief {
              margin-top: 8vw;
              h2 {
                font-size: 4.8vw;
                line-height: 5.6vw;
              }
              .brief-input {
                h3 {
                  font-size: 3.733vw;
                  line-height: 4.533vw;
                  top: -4vw;
                }
                textarea {
                  width: 90.667vw;
                  height: 7.2vw;

                  font-size: 4.267vw;
                  line-height: 5.067vw;
                }
              }
            }
          }
          .description {
            margin-top: 8vw;
            .editor {
              h3 {
                font-size: 3.733vw;
                line-height: 4.533vw;
                top: -6vw;
              }
            }
            h2 {
              font-size: 4.8vw;
              line-height: 5.6vw;
            }
          }
        }
      }

      .anotherLang {
        h1 {
          font-size: 5.867vw;
          line-height: 6.933vw;
        }
        .anotherLangContent {
          align-items: flex-start;
          .table {
            h2 {
              font-size: 4.8vw;
              line-height: 5.6vw;
            }
            .text {
              .text-input {
                h3 {
                  font-size: 3.233vw;
                  line-height: 4.533vw;
                  top: -4.5vw;
                }
                input {
                  width: 90.667vw;
                  height: 7.2vw;

                  font-size: 4.267vw;
                  line-height: 5.067vw;
                }
              }
            }
            .brief {
              margin-top: 8vw;
              h2 {
                font-size: 4.8vw;
                line-height: 5.6vw;
              }
              .brief-input {
                h3 {
                  font-size: 3.733vw;
                  line-height: 4.533vw;
                  top: -4vw;
                }
                textarea {
                  width: 90.667vw;
                  height: 7.2vw;

                  font-size: 4.267vw;
                  line-height: 5.067vw;
                }
              }
            }
          }
          .description {
            margin-top: 8vw;
            .editor {
              h3 {
                font-size: 3.733vw;
                line-height: 4.533vw;
                top: -6vw;
              }
            }
            h2 {
              font-size: 4.8vw;
              line-height: 5.6vw;
            }
          }
        }
      }

      .files {
        display: flex;
        flex-direction: column;
        .files-flex {
          margin-top: 0;
          display: grid;
          grid-template-rows: 14vw 5vw;
          width: 100%;
          margin-top: 8vw;
          .files-flex-content {
            display: flex;
            flex-direction: column;
            h2 {
              margin: 2vw 0;
            }
            .files-input {
              display: flex;
              flex-direction: column;
              width: 100%;
              h3 {
                font-size: 3.233vw;
                line-height: 5.067vw;
                left: 20vw;
                top: -7vw;
                width: max-content;
              }

              input {
                width: 36vw;
                height: 7.733vw;
                font-size: 4.267vw;
                line-height: 5vw;
              }
            }
          }

          button {
            width: 36vw;
            height: 7.733vw;
            font-size: 4.267vw;
            line-height: 5vw;
          }
          h3 {
            font-size: 3.733vw;
            line-height: 5.067vw;
            margin-top: 5vw;
          }
        }
        .display {
          display: flex;
          justify-content: center;
          margin-top: 10.333vw;
          .display-content {
            p {
              margin-right: 4vw;
            }
          }
          .image {
            width: 57.333vw;
            height: 42.933vw;
            position: relative;
            top: 0;
            right: 0;
          }
        }
      }

      .categories {
        display: grid;
        grid-template-areas:
          "h2TagTitle h2TagTitle"
          "avialable avialable"
          "arrow arrow"
          "selectedTags selectedTags"
          "newsLeft newsLeft"
          "status status"
          "date date"
          "country country"
          "checkbox checkbox";
        grid-template-columns: 89.6vw;
        position: relative;

        .tegi {
          margin-left: 0;
          padding-bottom: 2.667vw;
          h2 {
            font-size: 4.8vw;
            line-height: 4.8vw;
          }
        }
        .avialableSection {
          width: 89.6vw;
          margin-left: 0;
          .avialableTags {
            .avialableTitle {
              height: 9.067vw;
              h1 {
                font-size: 4.8vw;
                line-height: 4.8vw;
              }
            }

            .avialableSearch {
              input {
                width: 70.667vw;
                height: 7.2vw;
                margin-right: 5.333vw;
                font-size: 4.267vw;
                line-height: 5.067vw;
              }
              i {
                font-size: 4.267vw;
                line-height: 4.267vw;
                margin-right: 0;
              }
            }

            select {
              height: 53.333vw;
              option {
                font-size: 3.733vw;
                line-height: 4.533vw;
                margin-left: 3.2vw;
                margin-bottom: 1.067vw;
              }
            }
          }

          .selectAll {
            span {
              font-size: 4.267vw;
              line-height: 5.067vw;
            }

            .icon {
              width: 3.733vw;
              height: 3.733vw;
              i {
                font-size: 2.133vw;
                &:before {
                  content: "\f078";
                }
              }
            }
          }
        }

        .selectedTags {
          width: 89.6vw;
          margin-left: 0;
          margin-top: 5.667vw;
          h4 {
            font-size: 3.733vw;
            line-height: 4.533vw;
            width: 89.6vw;
            top: -4.5vw;
          }

          .selectedSection {
            .selectedTitle {
              height: 9.067vw;
              h1 {
                font-size: 4.8vw;
                line-height: 4.8vw;
              }
            }

            select {
              height: 53.333vw;
              option {
                font-size: 3.733vw;
                line-height: 4.533vw;
                margin-left: 3.2vw;
                margin-bottom: 1.067vw;
              }
            }
          }

          .deleteAll {
            span {
              font-size: 4.267vw;
              line-height: 5.067vw;
            }
            .icon {
              width: 3.733vw;
              height: 3.733vw;

              i {
                font-size: 2.133vw;
                &:before {
                  content: "\f077";
                }
              }
            }
          }
        }

        .arrows {
          display: flex;
          flex-direction: row;
          margin-top: 3vw;
          width: 20vw;

          .arrowLeft,
          .arrowRight {
            background: black;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            i {
              font-size: 2vw;
              width: 4vw;
              height: 4vw;
            }

            .arrowRight {
              i {
                &:before {
                  content: "\f078";
                }
              }
            }

            .arrowLeft {
              i {
                &::before {
                  content: "\f077";
                }
              }
            }
          }

          .arrowRight {
            i {
              padding: 0;

              &:before {
                content: "\f078";
              }
            }
          }

          .arrowLeft {
            margin-left: 5vw;

            i {
              padding: 0;
              &:before {
                content: "\f077";
              }
            }
          }
        }

        .news-left {
          display: flex;
          flex-direction: column;
          margin-top: 12vw;
          h3 {
            display: block;
            font-size: 3.733vw;
            line-height: 4.533vw;
          }
          .news {
            width: 100%;
            height: 8.8vw;
            display: grid;
            grid-template-columns: repeat(2, auto);
            h2 {
              width: 40vw;
            }
            select {
              width: 48.533vw;
              height: 8.8vw;
              font-size: 4.267vw;
              line-height: 5.067vw;
              option {
                font-size: 4.267vw;
                line-height: 5.067vw;
              }
            }
          }
        }

        .status {
          width: 100%;
          height: 8.8vw;
          display: grid;
          grid-template-columns: repeat(2, auto);
          margin-top: 12vw;
          margin-left: 0;
          h2 {
            font-size: 4vw;
            line-height: 4vw;
            width: 33vw;
          }
          select {
            width: 48.533vw;
            height: 8.8vw;
            font-size: 4.267vw;
            line-height: 5.067vw;
            option {
              font-size: 4.267vw;
              line-height: 5.067vw;
            }
          }
        }

        .check {
          justify-content: flex-start;
          padding-bottom: 12vw;
          input {
            width: 3.733vw;
            height: 3.733vw;
          }
          label {
            font-size: 4.267vw;
            line-height: 5.067vw;
            margin-left: 4vw;
          }
        }

        .date {
          margin-left: 0;
          height: 100%;
          .calendar {
            height: 20vw;
            h2 {
              margin-bottom: 3vw;
              font-size: 4vw;
              line-height: 4vw;
            }
          }
        }

        .country {
          width: 89.6vw;
          margin-left: 0;
          margin-top: 8vw;
          align-items: flex-start;

          h5 {
            font-size: 3.733vw;
            line-height: 4.533vw;
            width: 89.6vw;
            top: -4.5vw;
          }

          .countries {
            border: none;
            .countryTitle {
              height: max-content;
              background: transparent;
              h1 {
                font-size: 4.8vw;
                line-height: 5.867vw;
                font-weight: 500;
              }
            }

            .countrySearch {
              input {
                width: 70.667vw;
                height: 7.2vw;
                margin-right: 5.333vw;
                font-size: 4.267vw;
                line-height: 5.067vw;
              }
              i {
                font-size: 4.267vw;
                line-height: 4.267vw;
                margin-right: 0;
              }
            }

            select {
              width: 84vw;
              height: 8.8vw;
              background: var(--foreground-color);
              // background: black;
              margin-bottom: 2.133vw;
              margin-top: 8vw;
              margin-left: 4vw;
              font-size: 3.733vw;
              line-height: 4.533vw;
              option {
                font-size: 3.733vw;
                line-height: 4.533vw;
              }
            }
          }
          .selectCountry {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            padding-left: 4vw;
            button {
              width: 31.467vw;
              height: 10.4vw;
              background: #6c8fba;
              color: white;
            }

            p {
              font-size: 4.267vw;
              line-height: 5.067vw;
            }
          }
        }

        .regionsBar {
          width: 89.6vw;
          margin-left: 0;
          align-items: flex-start;
          margin-top: 8vw;
          h5 {
            font-size: 3.733vw;
            line-height: 4.533vw;
            width: 89.6vw;
            top: -4vw;
          }
          .regionsSelect {
            .regionsTitle {
              height: 9.067vw;
              background: transparent;
              h2 {
                font-size: 4.8vw;
                line-height: 4.8vw;
                font-weight: 500;
                color: rgba(69, 69, 69, 1);
              }
            }

            select {
              width: 84vw;
              height: 8.8vw;
              background: var(--foreground-color);
              margin-bottom: 2.133vw;
              margin-top: 8vw;
              margin-left: 4vw;
              option {
                font-size: 3.733vw;
                line-height: 4.533vw;
              }
            }

            button {
              margin-left: 4vw;
              width: 31.467vw;
              height: 10.4vw;
            }
            p {
              font-size: 4.267vw;
              line-height: 5.067vw;
              margin-left: 4vw;
            }
          }
        }
      }

      .links {
        .mr {
          padding-bottom: 6vw;
          margin-left: 0;
          .link {
            font-size: 4.267vw;
            line-height: 5.067vw;
            // padding: 3vw;
            width: 92vw;
            height: 12.533vw;
            &:nth-child(2) {
              width: 41.067vw;
            }
          }
        }
      }
    }
  }
}
</style>
